import * as Styled from './ClientJavascriptContent.styled';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';

/**
 * At the moment, ClientJavascriptContent does not need ClientJavascriptContentBlockDataProps.
 * Omitted because, in Typescript, empty interfaces accept any non-nullable value.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `ClientJavascriptContent` content block allows users to embed a sandboxed iframe.
 *
 * Allowed permissions: `allow-scripts`. At the moment, permissions cannot be overriden.
 *
 * ---
 *
 * ! 🚨**[WARNING] This page block is a proof-of-concept! Do not use!**🚨
 *
 *
 * PoC Notes:
 * - There are two ways to embed an iframe: `src` and `srcDoc`.
 *   - `src` is a URL to the page to embed, or a data URI representing the HTML to embed.
 *   - `srcDoc` is inline HTML to embed.
 *   - Including both for now to experiment with.
 * - The iframe's base URL is the parent document's URL, which is problematic for relative
 *   paths, but may be fixed with `<base href="...">`.
 *
 * ---
 *
 * Todo:
 * - Title prop
 * - How to intelligently set the width and height
 */
export const ClientJavascriptContent = _ref => {
  let {
    iframeWidth,
    iframeHeight,
    fit,
    src,
    srcDoc,
    parentLayoutInfo,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(StyledContentContainer, {
    parentLayoutInfo: parentLayoutInfo,
    fit: !!fit,
    children: /*#__PURE__*/_jsx(Styled.Iframe, {
      /**
       * Note, experimenting with src and srcDoc... one of them will probably go away.
       *
       * It might be overkill, but `srcdoc` may be preferred because it was added alongside
       * `sandbox` (as part of HTML5). If a browser doesn't support `sandbox`, it will load
       * `src` without any security restrictions. We're talking about IE <= 9 though.
       */
      src: src,
      srcDoc: srcDoc,
      "data-id": "cp-client-javascript-content"
      // TODO: needs accessible title
      ,
      width: fit ? '100%' : iframeWidth,
      height: iframeHeight,
      ...rest,
      /**
       * Place after `...rest` to prevent client overriding the sandbox attribute.
       * ! Do not add "allow-same-origin". It is a security risk.
       */
      sandbox: "allow-scripts"
    })
  });
};